'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UNAUTHENTICATED = 'UNAUTHENTICATED';
var UNAUTHORIZED = 'UNAUTHORIZED';
var ERROR_SNACKBAR = 'ERROR_SNACKBAR';
var SERVICE_UNREACHABLE = exports.SERVICE_UNREACHABLE = 'SERVICE_UNREACHABLE';
/**
 * This module houses various HTTP utilities that are used across the
 * various WCNG repositories.
 */

var HTTPUtils = function HTTPUtils() {
  _classCallCheck(this, HTTPUtils);
};

HTTPUtils.maxRetries = 5;
HTTPUtils.retryWaitTime = 5000;
HTTPUtils.retryTimeout = 0;
HTTPUtils.backoffFactor = 2;
HTTPUtils.axiosNoRetry = null;

HTTPUtils.initAxios = function (axios) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
  var responseType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'json';
  var withCredentials = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var localAxios = axios.create({
    timeout: timeout,
    responseType: responseType,
    withCredentials: withCredentials
  });
  localAxios.defaults.headers.common['Content-Type'] = 'application/json';
  HTTPUtils.axiosNoRetry = localAxios;
};

HTTPUtils.responseHandler = function (axios) {
  return function () {
    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof store.dispatch !== 'function') {
      throw new Error('You must pass a valid Redux store into this module!');
    }
    // default axios configs --
    axios.defaults.headers.get['Content-Type'] = 'application/json';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.put['Content-Type'] = 'application/json';
    axios.defaults.timeout = 10001;
    axios.defaults.withCredentials = true;

    // the response interceptor is not interested in success
    axios.interceptors.response.use(undefined, function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err) {
        var config, _err$config, retryDelay, _err$config$maxRetrie, maxRetries, dispatch, retry;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(err && err.code === 'ERR_CANCELED')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', Promise.reject(err));

              case 2:
                config = err.config;
                _err$config = err.config;
                _err$config = _err$config === undefined ? {} : _err$config;
                retryDelay = _err$config.retryDelay, _err$config$maxRetrie = _err$config.maxRetries, maxRetries = _err$config$maxRetrie === undefined ? HTTPUtils.maxRetries : _err$config$maxRetrie;
                dispatch = store.dispatch;


                config.retryCount = config.retryCount || 0;

                HTTPUtils.processError(config, store);

                // if there is a valid response, we don't want to retry, so reject the promise

                if (!err.response) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return', Promise.reject(err));

              case 11:
                if (!(config.retryCount >= maxRetries)) {
                  _context.next = 15;
                  break;
                }

                dispatch({
                  type: SERVICE_UNREACHABLE,
                  payload: {
                    open: true,
                    errorMessage: 'Sorry, the network seems to be down. Please try again later.'
                  }
                });
                console.error('[HTTPUtils] Something went wrong. Reached max retry for network error.');
                return _context.abrupt('return', Promise.reject(err));

              case 15:

                config.retryCount += 1;

                retry = new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve();
                  }, (retryDelay || HTTPUtils.retryWaitTime) * HTTPUtils.backoffFactor);
                });

                // retry the request

                _context.next = 19;
                return retry;

              case 19:
                return _context.abrupt('return', axios(config));

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function (_x5) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

HTTPUtils.processError = function (config, store) {
  if (!config) return;
  // Network or Timeout Error
  // cannot put in default of switch statement below because
  // hits TypeError -- cannot read status of undefined for error.response
  // not sure if this ever gets hit, leaving in jic parisi WC-4336
  if (config.code === 'ECONNABORTED') {
    if (config.retryCount % 2 === 1) {
      store.dispatch({
        type: ERROR_SNACKBAR,
        payload: {
          open: true,
          errorMessage: 'Network timeout, retrying request'
        }
      });
    }
    console.warn('[HTTPUtils] Network timeout, retrying request');
    return;
  }
  if (!config.response) {
    if (config.retryCount % 2 === 1) {
      store.dispatch({
        type: ERROR_SNACKBAR,
        payload: {
          open: true,
          errorMessage: 'Network failure, attempting to reconnect'
        }
      });
    }
    console.warn('[HTTPUtils] Network failure, attempting to reconnect');
  } else {
    switch (config.response.status) {
      case 400:
        store.dispatch({
          type: ERROR_SNACKBAR,
          payload: {
            open: true,
            errorMessage: config.response.data.validationErrors[0].message
          }
        });
        break;
      case 401:
        store.dispatch({
          type: UNAUTHENTICATED
        });
        break;
      case 403:
        store.dispatch({
          type: UNAUTHORIZED
        });
        break;
      case 500:
      case 503:
        console.error('\n            [HTTPUtils] There was an error when executing an HTTP request:\n            ' + config + '\n          ');
        store.dispatch({
          type: ERROR_SNACKBAR,
          payload: {
            open: true,
            errorMessage: 'Server error encountered'
          }
        });
        break;
      default:
        break;
    }
  }
};

exports.default = HTTPUtils;